// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_18wyjHOO-M02AcZaX1DUzU","placeholder":"_24TNyOCOZ5D_jcEV4W05gK","optionsWrapper":"_2IY-rAwh9b863TlSBSHXYH","option":"_3y30plM3IpU9yKOqIRFGhF","selected":"_8wTfGIhYgZHvCz5NwB22P","opened":"_1VZ-_wK-6QxrB5GBKiX3Yn","tab":"_3qwMv6d4ODngM6mOcFXVvC","selectedTab":"_2sH7vMOWsboUu3XyhAl4iV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMDropdown/OMDropdown.scss
// module id = 1653
// module chunks = 0